const bankValues = {
    xs: 12,
    sm: 16,
    md: 24,
    lg: 32,
    xl: 40,
};
const getBaseIconSize = () => {
    return bankValues;
};
const iconSize = (baseIconSize) => ({
    xs: `${baseIconSize.xs}px`,
    sm: `${baseIconSize.sm}px`,
    md: `${baseIconSize.md}px`,
    lg: `${baseIconSize.lg}px`,
    xl: `${baseIconSize.xl}px`,
});
const getIconSize = () => {
    return iconSize(bankValues);
};
export { getBaseIconSize, getIconSize };
//# sourceMappingURL=iconSizes.js.map